<template>
  <div class="item-audit">
    <span class="display-text">{{ audit.display_text }}</span>
    <div v-b-tooltip.hover.left :title="detailedDate(audit.created_at)"
         class="timestamp">
      {{prettyDate(audit.created_at)}}
    </div>
  </div>
</template>

<script>
import { helpersMixins } from '@/mixins/helpersMixins'
export default {
  name: 'MessageAudit',
  mixins: [helpersMixins],
  props: {
    audit: Object
  }
}
</script>

<style>
  .item-audit {
    padding: 12px 28px 9px 103px;
    overflow: auto;
    position: relative;
    font-size: 12px;
    color: #7A858E;
    font-weight: 400;
    text-align: left;
  }
  .display-text {

  }
  .timestamp {
    float: right;
    padding-left: 5px;
  }
  @media (max-width: 767px) {
    .item-audit {
      padding: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MessageAudit.vue